import request from './request'
const activity = 'ACTIVITY-SERVE'

// 新增调整时间
export function saveAdjustInfo(data) {
  return request({
    url: activity + '/act-plan-apply-adjust/save',
    method: 'post',
    data
  })
}

// 更新调整时间
export function updateAdjustInfo(data) {
  return request({
    url: activity + '/act-plan-apply-adjust/update',
    method: 'post',
    data
  })
}

// 调整记录
export function findAdjustList(data) {
  return request({
    url: activity + '/act-plan-apply-adjust/findList',
    method: 'post',
    data
  })
}
